export const withReportNavigationState = (study: any, reportInfo: any = {}) => ({
  ...study,
  reportId: reportInfo?.reportId || study?.reportId,
  reportStatus: reportInfo?.status || study?.reportStatus,
  reportType: reportInfo?.reportType || study?.reportType,
  reportAssignedTo: reportInfo?.reportAssignedTo || study?.reportAssignedTo,
});

export const resolveExistingReportId = (
  routeReportId: string | undefined,
  currentReport: any,
  currentStudyUID: string | undefined
) =>
  currentReport?._id && currentReport?.studyInstanceUID === currentStudyUID
    ? currentReport._id
    : routeReportId;
